<div class="container">
  <div class="row">
    <div class="col">
      <div [innerHTML]="getHtmlContent() | async"></div>
    </div>
  </div>
</div>
